export const ModulesMessages = {
    HOME_MODULE: 'Home',
    USERS_MODULE: 'Usuarios',
    EXPORT_MODULE: 'Exportar',
};
